import { OrderConfirmationPage } from '../pages/OrderConfirmationPage';

export function ResponsiveOrderConfirmationPage() {
  return <OrderConfirmationPage />;
}
